import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import { account } from "../../services/appwrite";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { checkUser } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log("Processing OAuth callback...");
        console.log("Current URL:", window.location.href);
        console.log("Hash:", window.location.hash);
        console.log("Search:", window.location.search);

        // Remove the hash fragment if present (Vercel adds this)
        if (window.location.hash === "#") {
          const newUrl = window.location.href.replace("#", "");
          window.history.replaceState({}, document.title, newUrl);
        }

        // Wait a bit for the session to be established
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // Get the current session to verify authentication
        const session = await account.getSession("current");
        console.log("Session:", session);

        // If we have a session, get the user
        if (session) {
          const userData = await checkUser();
          console.log("User data:", userData);
          navigate("/dashboard", { replace: true });
        } else {
          console.error("No session found");
          setError("Authentication failed. Please try again.");
          setTimeout(() => navigate("/login", { replace: true }), 3000);
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        setError(error.message || "Authentication failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 3000);
      }
    };

    handleCallback();
  }, [navigate, checkUser]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 2,
        p: 3,
      }}
    >
      {error ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      ) : (
        <>
          <CircularProgress />
          <Typography align="center">Completing authentication...</Typography>
          <Typography variant="caption" color="textSecondary">
            You will be redirected automatically
          </Typography>
        </>
      )}
    </Box>
  );
}
